import React, {} from 'react';

import MultiSelectField from '../common/fields/MultiSelectField';
import { useMasterData } from '../../contexts/MasterDataContext';

function TeachingInfoStep({ formData, setFormData, errors }) {
  const { mediumOptions, cityOptions, classTypeOptions, subjectOptions } = useMasterData();

  return (
    <div className="space-y-4">
      <MultiSelectField
        label="Subjects"
        value={formData.subjects}
        onChange={(value) => setFormData({ ...formData, subjects: value })}
        options={subjectOptions}
        error={!!errors?.subjects}
        helperText={errors?.subjects?.[0]}
        required
      />
      <MultiSelectField
        label="Medium of Teaching"
        value={formData.medium}
        onChange={(value) => setFormData({ ...formData, medium: value })}
        options={mediumOptions}
        error={!!errors?.medium}
        helperText={errors?.medium?.[0]}
        required
      />
      <MultiSelectField
        label="Class Types"
        value={formData.classTypes}
        onChange={(value) => setFormData({ ...formData, classTypes: value })}
        options={classTypeOptions}
        error={!!errors?.classTypes}
        helperText={errors?.classTypes?.[0]}
        required
      />
      <MultiSelectField
        label="Cities(If home visit)"
        value={formData.cities}
        onChange={(value) => setFormData({ ...formData, cities: value })}
        options={cityOptions}
        error={!!errors?.cities}
        helperText={errors?.cities?.[0]}
      />
    </div>
  );
}

export default TeachingInfoStep;
